<template>
  <div>
    <maintenance />
    <div v-if="!hideWorkspace">
      <mode-of-contact />
      <your-details v-if="token && token.length > 0" />
      <your-products v-if="step >= 2" />
      <your-request v-if="step >= 3" />
    </div>
  </div>
</template>

<script>
import ModeOfContact from "../components/ModeOfContact";
import YourDetails from "./YourDetails";
import YourProducts from "./YourProducts";
import YourRequest from "./YourRequest";
import Maintenance from "./Maintenance";
import Auth from "../mixins/auth";
import { mapState, mapMutations, mapActions } from "vuex";
import * as types from "../store/mutation-types";
import { i18n } from "../config";
import {
  languageCode,
  getStoreCodeByUrl,
  getStoreCountryNameByCode,
  storeList,
} from "../mixins/store";

export default {
  name: "Home",
  components: {
    ModeOfContact,
    YourDetails,
    YourProducts,
    YourRequest,
    Maintenance,
  },
  data: () => ({
    token: "",
    hideWorkspace: false,
  }),
  computed: {
    ...mapState({
      store: "store",
      step: "step",
    }),
  },
  watch: {
    // Re-evaluate the Zendesk widget whenever the store is resolved/changed.
    // The store is set asynchronously during the auth flow, so a one-shot
    // call can run before the store is known (e.g. before it becomes "sg").
    store: {
      immediate: true,
      handler() {
        this.toggleZendeskWidget();
      },
    },
  },
  methods: {
    // Show the Zendesk widget only for the supported stores; hide it
    // everywhere else. The snippet is loaded via a deferred script in
    // public/index.html, so window.zE may not be ready yet when this runs.
    toggleZendeskWidget() {
      const allowedStores = ["sg", "au", "us", "uk", "ca"];
      const action = allowedStores.indexOf(this.store) >= 0 ? "show" : "hide";

      // console.log({ store: this.store, action });

      const apply = () => {
        if (typeof window.zE !== "function") return false;
        try {
          window.zE("messenger", action);
        } catch (e) {
          window.zE("webWidget", action);
        }
        return true;
      };

      if (apply()) return;

      // zE not loaded yet (deferred snippet); retry until it is available.
      let attempts = 0;
      const timer = setInterval(() => {
        if (apply() || ++attempts > 50) clearInterval(timer);
      }, 200);
    },
    ...mapMutations({
      changeStore: types.CHANGE_STORE,
      changeStep: types.CHANGE_STEP,
      showPageLoading: types.SHOW_LOADING,
      hidePageLoading: types.HIDE_LOADING,
    }),
    ...mapActions({
      updatePageTitle: types.SET_PAGE_TITLE,
      updatePageDesc: types.SET_PAGE_DESC,
      updatePageLang: types.SET_PAGE_LANG,
    }),
  },
  async created() {
    // If timing hit, disable RMA page and show only the msg
    let dtNow = new Date();
    let dtStart = new Date("2022-10-09 8:30:00 AM");
    let dtEnd = new Date("2022-10-09 3:00:00 PM");

    // Home.vue
    if (dtNow >= dtStart && dtNow <= dtEnd) {
      this.hideWorkspace = true;
    }

    // guest authorization
    this.showPageLoading();
    let token = Auth.getToken();
    if (!token || token.length == 0)
      token = await Auth.authenticate(this.store);
    if (token && token.length > 0) Auth.updateToken(token);
    this.token = token;
    const code = getStoreCodeByUrl(location.href);
    const countryName = getStoreCountryNameByCode(this.store);
    if (code && storeList.indexOf(code) >= 0) this.changeStore(code);
    i18n.locale = languageCode[this.store] ? languageCode[this.store] : "en";
    this.$scrollTo("#app");
    this.hidePageLoading();

    if (i18n.locale == "en") {
      this.updatePageTitle(`${this.$t("page-title")} (${countryName})`);
    } else {
      this.updatePageTitle(`${this.$t("page-title")}`);
    }
    this.updatePageDesc(this.$t("page-desc"));

    switch (true) {
      case window.location.href.includes("enquiry/return"):
        if (!this.$t("page-title-return").includes("page-title-return")) {
          this.updatePageTitle(this.$t("page-title-return"));
          this.updatePageDesc(this.$t("page-desc-return"));
        }
        break;

      case window.location.href.includes("enquiry/replacement"):
        if (
          !this.$t("page-title-replacement").includes("page-title-replacement")
        ) {
          this.updatePageTitle(this.$t("page-title-replacement"));
          this.updatePageDesc(this.$t("page-desc-replacement"));
        }
        break;

      case window.location.href.includes("enquiry/rma-status"):
        if (
          !this.$t("page-title-checkstatus").includes("page-title-checkstatus")
        ) {
          this.updatePageTitle(this.$t("page-title-checkstatus"));
          this.updatePageDesc(this.$t("page-desc-checkstatus"));
        }
        break;
    }

    this.updatePageLang(i18n.locale);
  },
};
</script>
